import * as React from 'react'
import styled from 'styled-components'
import { ViewBase } from '@bestyled/primitives'
import { commonProps, CommonProps } from '@bestyled/system'

export type CenterProps = CommonProps

/** The Center component handles the flex box model, normalized for cross-platform with flutter like props. */
export const Center = styled(ViewBase<CenterProps>('Center'))`
  flex-wrap: nowrap;
  flex-direction: row;
  justify-content: center;
  align-content: center;
  ${commonProps}
` as React.FC<CenterProps>
